import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ss1 from '../../images/ss1.png'
import ss2 from '../../images/ss2.png'
import ss3 from '../../images/ss3.png'
import cars from '../../images/cars.png'
import book from '../../images/book.png'
import tour from '../../images/tour.png'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..

const Projects = () => {
    useEffect(()=>{
        AOS.init();

    })
    return (
    //     <div id='projects' className='pt-5 pb-5' style={{height:'100%',backgroundColor:'#1f2833',color:'white'}}>
    //    <Container data-aos="fade-up" data-aos-duration="3000" className="my-5 pb-5">
    //         <h2 className="text-white text-center mb-5">Projects</h2>
    //         <Row xs={1} md={2} lg={3}>
    //             <Col>
    //                 <div  data-aos="zoom-in" data-aos-duration="1000" style={{backgroundColor:'#191f27'}} className="project text-justify  card h-100 d-flex flex-column justify-content-between">
 
    //                     <div>
    //                         <img src={ss3}className="img-fluid" alt="" />
 
    //                     </div>
    //                     <div >
    //                         <h4 className=" mt-3">ExoticCars</h4>
    //                         <p>description</p>
    //                         <a href="https://exotic-cars-9e78b.web.app/" className="btn btn-dark my-3">Live Site</a>
    //                     </div>
    //                 </div>
    //             </Col>
    //             <Col>
    //                 <div  data-aos="zoom-in" data-aos-duration="1000" style={{backgroundColor:'#191f27'}} className="project text-justify card h-100 d-flex flex-column justify-content-between">
 
    //                     <div>
    //                         <img src={ss1} className="img-fluid" alt="" />
 
    //                     </div>
    //                     <div>
    //                         <h4 className=" mt-3">HealthyGYM</h4>
    //                         <p>description</p>
    //                         <a href="https://healthcare-ad401.web.app/home" className="btn btn-dark my-3">Live Site</a>
    //                     </div>
    //                 </div>
    //             </Col>
    //             <Col>
    //                 <div  data-aos="zoom-in" data-aos-duration="1000" style={{backgroundColor:'#191f27'}} className="project text-justify card h-100 d-flex flex-column justify-content-between">
 
    //                     <div>
    //                         <img src={ss2} className="img-fluid" alt="" />
 
    //                     </div>
    //                     <div>
    //                         <h4 className=" mt-3">Travelo</h4>
    //                         <p>description</p>
    //                         <button href="https://toursimwebsite-9eecc.web.app/" className="btn btn-dark my-3">Live Site</button>
    //                     </div>
    //                 </div>
    //             </Col>
    //         </Row>
    //     </Container>
            
    //     </div>




        <div  id='projects' style={{backgroundColor:'rgb(30, 30, 40)'}}>
            <h1 style={{color:'white', padding:'100px'}}>Portfolio</h1>

            <div className='container'>
            <div  className='row p-5' style={{backgroundColor:'rgb(30, 30, 40)'}}>
           <div data-aos="zoom-in" data-aos-duration="3050" className='col-md-6 col-sm-12' style={{border:'2px solid #1f2833', backgroundColor:'#1f2833', boxShadow:'5px 10px', width:'400px' }}>
               <img className='w-75 px-auto mx-auto' src={cars} alt='' style={{width:'100px', marginTop:'50px'}}></img>
              
          

           </div>
           <div data-aos="fade-up" data-aos-duration="3010" className='col-md-6 col-sm-12' style={{padding:'80px',color:'#cc6666'}}>
               <h5 style={{margin:'0'}}>Exotic cars</h5>
               <p>- A car buying and selling website<br></br>
              - Have user authraization functionality<br></br>
              - Admin can add or remove products also can add admin
                </p>
                <a href="https://exotic-cars-9e78b.web.app/" className="btn btn-dark my-3 mx-1">Live Site</a>
                <a href="https://exotic-cars-9e78b.web.app/" className="btn btn-dark my-3">Github</a>



           </div>
           
       </div>
             <div  className='row p-5' style={{backgroundColor:'rgb(30, 30, 40)'}}>
           <div data-aos="zoom-in" data-aos-duration="3100" className='col-md-6 col-sm-12' style={{border:'2px solid #1f2833', backgroundColor:'#1f2833', boxShadow:'5px 10px', width:'400px'}}>
               <img className='w-75 px-auto mx-auto' src={book} alt='' style={{width:'100px', marginTop:'50px'}}></img>
              
          

           </div>
           <div data-aos="fade-up" data-aos-duration="3050" className='col-md-6 col-sm-12' style={{padding:'80px',color:'#cc6666'}}>
               <h5 style={{margin:'0'}}>BookHolics</h5>
               <p>- A book buying and selling website<br></br>
              - Have user authraization functionality<br></br>
              - Admin can add or remove products also can add admin
                </p>
                <a href="https://bookholic-53a60.web.app/" className="btn btn-dark my-3 mx-1">Live Site</a>
                <a href="https://github.com/faraz12948/bookholic" className="btn btn-dark my-3">Github</a>



           </div>
           
       </div>
             <div  className='row p-5' style={{backgroundColor:'rgb(30, 30, 40)'}}>
           <div data-aos="zoom-in" data-aos-duration="3100" className='col-md-6 col-sm-12' style={{border:'2px solid #1f2833', backgroundColor:'#1f2833', boxShadow:'5px 10px', width:'400px'}}>
               <img className='w-75 px-auto mx-auto' src={tour} alt='' style={{width:'100px', marginTop:'50px'}}></img>
              
          

           </div>
           <div data-aos="fade-up" data-aos-duration="3050" className='col-md-6 col-sm-12' style={{padding:'80px',color:'#cc6666'}}>
               <h5 style={{margin:'0'}}>Travelo</h5>
               <p>- A toursim website<br></br>
              - Have user authraization functionality<br></br>
              - User can book touring spot easily
                </p>
                <a href="https://toursimwebsite-9eecc.web.app/" className="btn btn-dark my-3 mx-1">Live Site</a>
                <a href="https://github.com/faraz12948/tourism-website-mern" className="btn btn-dark my-3">Github</a>



           </div>
           
       </div>
            </div>
        </div>
















    );
};

export default Projects;